<div class="auth-page auth-page--flow">
  <div class="auth-page__grid">
    <app-auth-showcase-aside />

<main class="auth-main auth-main--flow auth-main--dense">
      <div class="auth-main__content">
        <a class="auth-brand" [routerLink]="['/authentication']">
          <img
            src="/assets/images/logos/logo.svg"
            class="auth-brand__logo"
            [attr.alt]="'auth.chooseWorkspace.logoAlt' | translate"
          />
        </a>

        <div class="auth-panel choose-workspace">
          <h1 class="auth-panel__title">
            {{ 'auth.chooseWorkspace.title' | translate }}
          </h1>
          <p class="auth-panel__subtitle">
            {{ 'auth.chooseWorkspace.subtitle' | translate }}
          </p>

          @if (resume(); as last) {
            <button
              type="button"
              class="choose-workspace__resume"
              (click)="continueWhereLeft()"
            >
              <span class="choose-workspace__resume-label">
                {{ 'auth.chooseWorkspace.continueLast' | translate }}
              </span>
              <span class="choose-workspace__resume-target">
                {{ last.company.name }}
              </span>
            </button>
          }

          <ul class="choose-workspace__list" role="list">
            @for (company of companies(); track company.id) {
              <li>
                <app-workspace-company-card
                  [company]="company"
                  (selected)="pickCompany($event)"
                />
              </li>
            }
          </ul>

          <button
            type="button"
            class="choose-workspace__create"
            (click)="openOwnBusiness()"
          >
            <span class="choose-workspace__create-title">
              {{ createTitleKey() | translate }}
            </span>
            <span class="choose-workspace__create-hint">
              {{ createHintKey() | translate }}
            </span>
          </button>
        </div>
      </div>
    </main>
  </div>
</div>
